export const MARKER_CONFIG = {
  fieldMarker: "status",
  colorMapping: {
    pending: "#F0B100",
    canceled: "#E7000B",
    waiting_ok: "#FF784B",
    concluded: "#32BC9B",
    undefined: "#6b7280",
  },
};
